export * from './ProductDetailSlotsValue';
export * from './ProductDetailSlotsDTO';
export * from './ProductDetailSlotsRepository';
export * from './mocks';
